import { render, staticRenderFns } from "./_base-small-spinner.vue?vue&type=template&id=6751fd91&scoped=true"
var script = {}
import style0 from "./_base-small-spinner.vue?vue&type=style&index=0&id=6751fd91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6751fd91",
  null
  
)

export default component.exports